import { useContext, useState } from 'react';
import { Alert, Button, Modal, Tag } from 'antd';
import styles from 'styles/components/upgradeBanner.module.scss';
import ProfileContext from 'services/profileContext';
import { getApiURL, getSessionId } from 'utils/utils';
import pluralize from 'pluralize';

const UpgradeButton = ({ style, ...additionalProps }) => {
  const [yearly, setYearly] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { profile } = useContext(ProfileContext);
  const subscribe = () => {
    window.location.href = `${getApiURL()}/web-app/admin/workspaces/subscribe?sessionid=${getSessionId()}${yearly ? '&yearly=true' : ''
      }`;
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          setIsModalOpen(true);
        }}
        className={styles.button}
        size="small"
        style={style}
        {...additionalProps}
      >
        Upgrade now
      </Button>
      <Modal
        title="Upgrade to continue using the app"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <div className={styles.planTitle}>Choose a plan:</div>
        <div
          className={`${styles.planContainer} ${yearly ? '' : styles.selected}`}
          onClick={() => {
            setYearly(false);
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Monthly</div>{' '}
          <div>
            <b>$3.75</b> per user per month
          </div>
        </div>
        <div
          className={`${styles.planContainer} ${yearly ? styles.selected : ''}`}
          onClick={() => {
            setYearly(true);
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div style={{ fontWeight: 'bold' }}>Yearly</div>
            <Tag color="red" style={{ marginLeft: 4 }}>
              -20%
            </Tag>
          </div>
          <div>
            <b>$3</b> per user per month
          </div>
        </div>
        {!profile.workspace?.slack && (
          <div
            style={{ marginBottom: 12, color: '#919191', textAlign: 'center' }}
          >
            You currently have {profile.workspace?.seats} {pluralize('seat', profile.workspace?.seats)} used
          </div>
        )}
        <div>
          <Alert
            icon={<img src="/img/buddieshr.png" alt="Culture & Performance" style={{ width: 28, height: 28 }} />}
            showIcon type="info" description={<div>
              <b>SimplePerf subscription includes BuddiesHR Culture OS, <a target="_blank" rel="noopener noreferrer" href="https://buddieshr.com/pricing">all details about Culture & Performance plan here.</a></b></div>} />

        </div>
        <div style={{ marginTop: 12 }}>
          <Button
            block
            type="primary"
            onClick={() => {
              subscribe();
            }}
          >
            {profile.workspace?.slack
              ? `Subscribe${yearly ? ' (yearly)' : ''}`
              : `Subscribe - $${profile.workspace?.seats * (yearly ? 3 : 5)} per month${yearly ? ' (paid yearly)' : ''}`}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default UpgradeButton;
